/**
 * Reducer for all authentication-related activities
 */
import Constants from '../constants/DevAuthConstants';
import { fromJS, Map as IMap } from 'immutable';
// import update from 'react-addons-update';

const initialState = fromJS(IMap({ isFetching: false }));

/**
 * ## auth function
 * @param {Object} state - initialState
 * @param {Object} action - type and data
 */
export default function devAuth (state = initialState, action = null) {
  switch (action.type) {
    /**
     * ### REQUESTS (start)
     */
    case Constants.DEV_AUTH_REQUEST:
      return state.set('isFetching', true);

    /**
     * ### SUCCESS (request ended with success)
     */
    case Constants.DEV_AUTH_SUCCESS:
      return state.set('isFetching', false);

    /**
     * ### FAILURE (request ended with error)
     */
    case Constants.DEV_AUTH_FAILURE:
      return state.set('isFetching', false);

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/DevAuthReducer.js